import "./ViewPermissions.scss";

import { getResource, isResourceKey } from "providers";
import React from "react";

import { BiShieldCheck } from "./Icons/BiShieldCheck";

const skipKeys = ["isDeleting", "isUpdating", "issueDate"];

/*
const pickProps = (key, value) => {
  if (!key) return value; // root
  if (skipKeys.includes(key)) return undefined; // frontend transient properties
  const m = key.match(/^(can|is)/i);
  const include = m && m.length > 0 ? value : undefined;
  return include;
};

const dumpJson = (permissions) =>
  JSON.stringify(permissions, pickProps, 2)
    .replace(/^[{"srn]|[}"srn]$/gi, '')
    .replace(/\\?"/gi, '')
    .trim();
*/

function dump(item?: object) {
  try {
    let entries = Object.entries(item || {});
    entries = entries.sort((a, b) => a[0].localeCompare(b[0]));

    return entries
      .map(([key, value]) => {
        if (skipKeys.includes(key)) return null;
        if (!key.match(/^(can|is)/i)) return null;
        return `${key}: ${value}`;
      })
      .filter((x) => x)
      .join(", ");
  } catch (ex) {
    return `${ex}`;
  }
}

interface ViewPermissionsProps {
  item?: object;
  type: string;
}

export const ViewPermissions: React.FC<ViewPermissionsProps> = ({ item, type }) => {
  const objectDumped = dump(item);
  const typeLabel = isResourceKey(type) ? getResource(type) : type;
  const tooltip = [`<b>${typeLabel}</b>:`, objectDumped, ""];

  return (
    <span className="show-permissions global-tooltip-trigger" title={tooltip.join("\n")} data-placement="top">
      <BiShieldCheck />
    </span>
  );
};
